export default __webpack_public_path__ + "static/rulesBg-41423293d0304612b0fa44adc0b154ae.jpg";